import { getLocale } from '../misc';

const getFormattedPrice = price => {
  const locale = getLocale();
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2
  });
  return formatter.format(price).replace('CA', '');
};

export default getFormattedPrice;
